import TermsOfUseLink from './TermsOfUseLink';

export default TermsOfUseLink;
